(function() {
  // Changing a size re-renders the product section, and for the moment between
  // the tap and the new markup the column collapses: the gallery empties, the
  // add-to-cart disappears — the product template's own custom CSS hides a
  // disabled button outright — and everything below jumps up to fill the gap.
  //
  // None of that is ours to remove; the theme's <product-rerender> owns the
  // swap. What can be removed is the jump. The column is pinned at the height
  // it already had and dimmed while the swap is in flight, so the page holds
  // still and the moment reads as loading rather than as something breaking.
  var RELEASE_AFTER_MS = 3000;

  var held = [];
  var releaseTimer = null;
  var observer = null;

  // Which element to hold, and it is not the obvious one. <product-rerender> is
  // `display: contents` in the theme's stylesheet: it generates no box at all,
  // so a min-height on it is ignored outright — and `getBoundingClientRect`
  // still answers with the union of its children, so it looks like it worked.
  // That is the first version of this file, holding an element that cannot be
  // held while the page went on jumping.
  //
  // So it climbs to the first ancestor that actually generates a block box,
  // which on a Shopify page is the section wrapper. Holding that means nothing
  // below the product can move, whatever empties inside it.
  function boxed(node) {
    if (!window.getComputedStyle) return true;

    var display = window.getComputedStyle(node).display;
    return display !== 'contents' && display !== 'inline';
  }

  function targets() {
    var anchor = document.querySelector('[id^="product-info-"]');
    if (!anchor || anchor.closest('.zrx-sticky-atc-bar')) return [];

    var node = anchor.closest('.shopify-section') || anchor.parentElement;
    while (node && node !== document.body && !boxed(node)) {
      node = node.parentElement;
    }

    if (!node || node === document.body) return [];
    return node.getBoundingClientRect().height > 0 ? [node] : [];
  }

  function isSizeChange(target) {
    if (!target || !target.matches) return false;
    if (target.matches('.zrx-sticky-atc-select')) return true;

    return target.matches('input[data-option-position]') && !target.closest('.zrx-sticky-atc-bar');
  }

  function hold() {
    if (held.length) {
      // Already holding: a second tap before the first swap landed. Keep the
      // heights taken then — they are the ones with content behind them — and
      // just push the deadline out.
      restartTimer();
      return;
    }

    held = targets().map(function(node) {
      var height = Math.round(node.getBoundingClientRect().height);
      var previous = node.style.minHeight;
      node.style.minHeight = height + 'px';
      node.classList.add('sks-variant-swapping');
      return { node: node, previous: previous };
    });

    if (!held.length) return;

    watch();
    restartTimer();
  }

  function release() {
    if (releaseTimer !== null) {
      window.clearTimeout(releaseTimer);
      releaseTimer = null;
    }
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    held.forEach(function(entry) {
      entry.node.classList.remove('sks-variant-swapping');
      entry.node.style.minHeight = entry.previous;
    });
    held = [];
  }

  function restartTimer() {
    if (releaseTimer !== null) window.clearTimeout(releaseTimer);
    // The swap may never come — a failed request, a variant with nothing to
    // re-render. A held column that is never released is worse than the jump.
    releaseTimer = window.setTimeout(release, RELEASE_AFTER_MS);
  }

  // The end of the swap, watched rather than listened for: the theme dispatches
  // `product:rerender` on the product form without bubbles, and that form is
  // itself inside the markup being replaced. New nodes arriving in the column
  // is the same signal and survives the replacement.
  function watch() {
    if (typeof MutationObserver === 'undefined') return;

    observer = new MutationObserver(function(mutations) {
      var swapped = mutations.some(function(mutation) {
        return mutation.addedNodes && mutation.addedNodes.length > 0;
      });
      if (!swapped) return;

      // One frame after the new markup lands, so it is measured and painted
      // before the floor under it is taken away.
      window.requestAnimationFrame(function() {
        window.requestAnimationFrame(release);
      });
    });

    held.forEach(function(entry) {
      observer.observe(entry.node, { childList: true, subtree: true });
    });
  }

  document.addEventListener('change', function(event) {
    if (isSizeChange(event.target)) hold();
  }, true);

  // ------------------------------------------------------------------ //
  // Blocks that should sit the swap out                                  //
  // ------------------------------------------------------------------ //

  // Holding the page still stops it jumping; it does not stop the content
  // inside from blinking. The theme replaces every `liquid` block on a variant
  // change, and three of ours pay a visible price for it: the PayPal
  // instalment message, the size recommender's button and the size guide's.
  // Each is drawn by a script that has to fetch something before it can show
  // anything, so each comes back from the server empty and stays empty for a
  // round trip — on every single size a shopper tries.
  //
  // None of their content depends on the variant. The PayPal amount is
  // `product.price`, which is the product's minimum and identical either way;
  // a size chart belongs to the product, not to the size.
  //
  // Only `liquid` blocks, and that is a hard limit rather than a convenience.
  // The size guide's button lives inside the variant picker, which has to
  // re-render — it is what redraws availability on every swatch — so it is
  // fixed at its own source instead, by remembering the chart it fetched
  // (snippets/size-chart-button.liquid) rather than fetching it again.
  //
  // So they sit the swap out. The matcher pairs the old block with the new one
  // by `data-block-id`, and skips the pair when there is no match:
  //
  //     i = a.querySelector(`[data-block-type="..."][data-block-id="..."]`);
  //     i && (... e.replaceWith(i))
  //
  // Renaming the id is therefore the whole opt-out. `data-block-type` is left
  // alone deliberately — the theme's stylesheet reads it for block spacing, and
  // changing it would quietly close the gaps between these blocks.
  var KEEP_SELECTORS = ['.sks-paypal-message', '#sz-wrap'];

  function keepThroughSwap() {
    // Never in the theme editor: the block ids are how it finds what a merchant
    // just clicked on in the sidebar.
    if (window.Shopify && window.Shopify.designMode) return;

    KEEP_SELECTORS.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(node) {
        var block = node.closest('[data-block-type="liquid"][data-block-id]');
        if (!block || block.closest('.zrx-sticky-atc-bar')) return;

        var id = block.getAttribute('data-block-id');
        if (id.indexOf('sks-kept-') === 0) return;

        block.setAttribute('data-block-id', 'sks-kept-' + id);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', keepThroughSwap);
  } else {
    keepThroughSwap();
  }
}());
